const getPolicyType = (policyType) => {
  if (!policyType) return ''

  // replace extra characters from str
  // support for the case when patner provides 'home&Auto' instead of 'homeAndAuto'
  const rawStr = policyType.toLowerCase().replace(/\W/g, '')

  switch (rawStr) {
    case 'homeauto':
    case 'homeandauto':
      return 'homeAndAuto'

    case 'home':
      return 'home'

    case 'auto':
      return 'auto'

    default:
      return ''
  }
}

export default getPolicyType
